(function () {
  var cfg = window.TTIntelligentFitment || {};
  var API_BASE = String(cfg.apiBase || "").replace(/\/$/, "");
  var CLOSE_LOOP = String(cfg.closeLoopUrl || "https://tracktech-order-plus.vercel.app").replace(/\/$/, "");
  var FITMENT_PATH = "/api/storefront/intelligent-fitment";
  var makeInput = document.getElementById("ttq-make");
  var modelInput = document.getElementById("ttq-model");
  var sizeSelect = document.getElementById("ttq-size");
  var sizeField = document.getElementById("ttq-size-field");
  var configField = document.getElementById("ttq-config-field");
  var configSelect = document.getElementById("ttq-config");
  var sizeSummary = document.getElementById("ttq-size-summary");
  var partsBox = document.getElementById("ttq-parts");
  var treadSelect = document.getElementById("ttq-tread");
  var formEl = document.getElementById("ttq-form");
  var submitBtn = document.getElementById("ttq-submit");
  var statusEl = document.getElementById("ttq-status");
  var thanksEl = document.getElementById("ttq-thanks");
  var thanksSubEl = document.getElementById("ttq-thanks-sub");
  var thanksMetaEl = document.getElementById("ttq-thanks-meta");
  var thanksNewBtn = document.getElementById("ttq-thanks-new");
  var thanksPriceEl = document.getElementById("ttq-thanks-price");
  var thanksCheckout = document.getElementById("ttq-thanks-checkout");
  var machineDisplayField = document.getElementById("ttq-machine-display");
  var fitmentUrlField = document.getElementById("ttq-fitment-url");
  var variantIdsField = document.getElementById("ttq-variant-ids");
  var variantDetailField = document.getElementById("ttq-variant-detail");
  var equipmentHandleField = document.getElementById("ttq-equipment-handle");
  var quoteLinesField = document.getElementById("ttq-quote-lines");
  var quoteSourceField = document.getElementById("ttq-quote-source");
  if (formEl) formEl.target = "ttq-hidden-target";

  var QUOTE_BAG_MODE = false;
  var QUOTE_BAG_LINES = [];
  var LAST_IDEMPOTENCY = "";
  var LAST_MACHINE = null;

  function show_stamp_field() {
    return false;
  }

  function selectedModelLabel() {
    if (!modelInput || !modelInput.selectedOptions || !modelInput.selectedOptions[0]) return val("ttq-model");
    return modelInput.selectedOptions[0].dataset.model || val("ttq-model");
  }

  function isSteelOrUcLine(item) {
    if (!item) return false;
    var handle = String(item.handle || "").toLowerCase();
    var title = String(item.title || "").toLowerCase();
    var fam = String(item.family || item.productFamily || item.productType || item.partType || "").toLowerCase();
    var sku = String(item.sku || "").toUpperCase();
    if (/-rubber-tracks$/.test(handle)) return false;
    if (/rubber track/.test(fam + " " + title)) return false;
    if (/idler|roller|sprocket|pad|undercarriage/.test(fam + " " + title + " " + handle)) return true;
    return /^(RR|CR|FI|BO|CO|HT|ST|CT|TA)/.test(sku);
  }

  function lineLooksInStock(item) {
    if (!item) return false;
    if (item.available === false || item.inStock === false) return false;
    var q = item.inventoryQuantity != null ? item.inventoryQuantity : item.availableQty;
    if (q != null && Number(q) <= 0) return false;
    return true;
  }

  function bagLinesPayload() {
    return QUOTE_BAG_LINES.map(function (item) {
      return {
        shopify_variant_id: item.variantId || "",
        sku: item.sku || "",
        product_title: item.title || "",
        qty: Math.max(1, parseInt(item.qty, 10) || 1),
        family: item.family || item.productType || item.partType || "",
      };
    }).filter(function (row) {
      return row.shopify_variant_id || row.sku || row.product_title;
    });
  }

  function canShowCertifiedPay(result) {
    if (!result || !result.certified || !result.checkout_url) return false;
    if (result.qty === 0 || result.in_stock === false || result.available === false) return false;
    if (!QUOTE_BAG_LINES.length) return false;
    if (!QUOTE_BAG_LINES.every(isSteelOrUcLine)) return false;
    return QUOTE_BAG_LINES.every(lineLooksInStock);
  }

  function apiPost(path, payload) {
    return fetch(API_BASE + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
      credentials: "omit"
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
        if (!r.ok) throw new Error((j && j.error) || ("HTTP " + r.status));
        return j;
      });
    });
  }
  function val(id) {
    var el = document.getElementById(id);
    return el ? String(el.value || "").trim() : "";
  }
  function setStatus(kind, msg) {
    if (!statusEl) return;
    statusEl.className = "ttq-status is-active is-" + kind;
    statusEl.textContent = msg;
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "ttq-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }
  function hideStamp() {
    if (show_stamp_field()) return;
    if (sizeField) sizeField.hidden = true;
    if (sizeSelect) {
      sizeSelect.required = false;
      sizeSelect.disabled = true;
    }
    if (configField) configField.hidden = true;
    if (sizeSummary) sizeSummary.hidden = true;
  }
  hideStamp();

  function collectWantedParts() {
    var out = [];
    if (!partsBox) return out;
    partsBox.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      out.push(cb.value);
    });
    return out;
  }

  var PART_FAMILY_BUCKETS = {
    "Rubber Tracks": ["canonical_tracks", "rubber_tracks"],
    "Drive Sprockets": ["drive_sprockets"],
    "Front Idlers": ["front_idlers"],
    "Rear Idlers": ["rear_idlers"],
    "Bottom Rollers": ["bottom_rollers"],
    "Top Rollers": ["carrier_rollers"]
  };

  function normalizePartFamily(family) {
    var raw = String(family || "").trim().toLowerCase();
    if (raw.indexOf("rubber") !== -1 || raw === "tracks") return "Rubber Tracks";
    if (raw.indexOf("sprocket") !== -1) return "Drive Sprockets";
    if (raw.indexOf("front") !== -1 && raw.indexOf("idler") !== -1) return "Front Idlers";
    if (raw.indexOf("rear") !== -1 && raw.indexOf("idler") !== -1) return "Rear Idlers";
    if (raw.indexOf("bottom") !== -1 && raw.indexOf("roller") !== -1) return "Bottom Rollers";
    if ((raw.indexOf("top") !== -1 && raw.indexOf("roller") !== -1) || raw.indexOf("carrier") !== -1) return "Top Rollers";
    return String(family || "").trim();
  }

  function uniqueProducts(rows) {
    var seen = {};
    var out = [];
    (rows || []).forEach(function (row) {
      if (!row) return;
      var key = String(row.handle || row.id || row.title || "").toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(row);
    });
    return out;
  }

  function productsForFamily(machine, family) {
    var keys = PART_FAMILY_BUCKETS[normalizePartFamily(family)] || [];
    var rows = [];
    keys.forEach(function (key) {
      ((machine && machine[key]) || []).forEach(function (row) { rows.push(row); });
    });
    return uniqueProducts(rows);
  }

  function parseEmbeddedJson(text) {
    var j = null;
    try { j = text ? JSON.parse(text) : null; } catch (e) {
      var start = text.indexOf("{");
      var end = text.lastIndexOf("}");
      if (start >= 0 && end > start) {
        try { j = JSON.parse(text.slice(start, end + 1)); } catch (err) { j = null; }
      }
    }
    return j;
  }

  function loadMachineGraph() {
    if (LAST_MACHINE && (LAST_MACHINE.front_idlers || LAST_MACHINE.rubber_tracks || LAST_MACHINE.drive_sprockets || (LAST_MACHINE.equipment && LAST_MACHINE.equipment.handle))) {
      return Promise.resolve(LAST_MACHINE);
    }
    var handle = equipmentHandleField && equipmentHandleField.value;
    if (!handle) return Promise.resolve(null);
    return fetch("/collections/" + encodeURIComponent(handle) + "?view=tt-equipment-machine", {
      credentials: "omit",
      headers: { Accept: "application/json, text/plain, */*" }
    }).then(function (r) { return r.text(); }).then(function (t) {
      var j = parseEmbeddedJson(t);
      if (j) LAST_MACHINE = j;
      return j;
    }).catch(function () { return LAST_MACHINE; });
  }

  function fetchVariantId(handle) {
    if (!handle) return Promise.resolve("");
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        return p && p.variants && p.variants[0] && p.variants[0].id ? String(p.variants[0].id) : "";
      })
      .catch(function () { return ""; });
  }

  function linesFromMachine(machine, families, tread) {
    var machineLabel = [val("ttq-make"), selectedModelLabel()].filter(Boolean).join(" ") || "Quote request";
    var lines = [];
    (families || []).forEach(function (part) {
      var family = normalizePartFamily(part);
      var products = productsForFamily(machine, family);
      if (family === "Rubber Tracks") {
        if (tread) {
          var matched = products.filter(function (p) {
            return String(p.title || "").toLowerCase().indexOf(String(tread).toLowerCase()) !== -1;
          });
          if (matched.length) products = matched;
        }
        if (products.length !== 1) {
          lines.push({ shopify_variant_id: "", product_title: machineLabel + " — " + family, qty: 1, family: family });
          return;
        }
      }
      if (!products.length) {
        lines.push({ shopify_variant_id: "", product_title: machineLabel + " — " + family, qty: 1, family: family });
        return;
      }
      products.forEach(function (p) {
        lines.push({
          shopify_variant_id: p.variant_id || p.variantId || "",
          product_title: p.title || family,
          qty: 1,
          family: family,
          handle: p.handle || ""
        });
      });
    });
    return lines;
  }

  function hydrateClientLines(lines) {
    return Promise.all((lines || []).map(function (line) {
      if (line.shopify_variant_id || !line.handle) return Promise.resolve(line);
      return fetchVariantId(line.handle).then(function (id) {
        if (id) line.shopify_variant_id = id;
        return line;
      });
    }));
  }

  function stampQuoteFields(lines) {
    if (variantIdsField) {
      variantIdsField.value = (lines || []).map(function (l) { return l.shopify_variant_id; }).filter(Boolean).join(",");
    }
    var labels = (lines || []).map(function (l) {
      return (l.qty ? l.qty + "× " : "") + (l.product_title || l.family || "Item");
    });
    if (variantDetailField) variantDetailField.value = labels.join("\n");
    if (quoteLinesField) quoteLinesField.value = labels.join("\n");
  }

  function resolveSubmitLines() {
    var bag = bagLinesPayload();
    if (bag.length) {
      stampQuoteFields(bag);
      return Promise.resolve(bag);
    }
    var families = collectWantedParts();
    if (!families.length) return Promise.resolve([]);
    return loadMachineGraph().then(function (machine) {
      return hydrateClientLines(linesFromMachine(machine, families, treadSelect ? treadSelect.value : ""));
    }).then(function (lines) {
      stampQuoteFields(lines);
      return lines;
    }).catch(function () { return []; });
  }

  function loadQuoteBagLines() {
    try {
      if (window.TTQuoteBag && typeof window.TTQuoteBag.load === "function") {
        var bag = window.TTQuoteBag.load();
        if (bag && Array.isArray(bag.lines)) return bag.lines.slice();
      }
      var raw = window.localStorage.getItem("tt_quote_bag_v2") || window.localStorage.getItem("tt_quote_bag_v1");
      var parsed = raw ? JSON.parse(raw) : null;
      if (parsed && Array.isArray(parsed.lines)) return parsed.lines.slice();
    } catch (e) { /* ignore */ }
    return [];
  }

  function bagLineLabel(item) {
    if (!item) return "Item";
    return [
      (item.qty ? item.qty + "× " : "") + (item.title || item.sku || "Item"),
      item.variantLabel || item.variantTitle || [item.trackSize, item.treadPattern].filter(Boolean).join(" – ")
    ].filter(Boolean).join(" — ");
  }

  function bagNotes() {
    return QUOTE_BAG_LINES.map(bagLineLabel).filter(Boolean).join("\n");
  }

  function firstBagVariant() {
    var i;
    for (i = 0; i < QUOTE_BAG_LINES.length; i += 1) {
      if (QUOTE_BAG_LINES[i] && QUOTE_BAG_LINES[i].variantId) return QUOTE_BAG_LINES[i];
    }
    return QUOTE_BAG_LINES[0] || null;
  }

  function setEquipRequired(on) {
    if (makeInput) makeInput.required = !!on;
    if (modelInput) modelInput.required = !!on;
  }

  function applyQuoteBag() {
    var qs = quoteQuery();
    var source = qs.get("source") || "";
    var lines = loadQuoteBagLines();
    if (!lines.length && (qs.get("product") || qs.get("variant") || qs.get("sku") || qs.get("title"))) {
      lines = [{
        handle: qs.get("product") || "",
        variantId: qs.get("variant") || "",
        sku: qs.get("sku") || "",
        title: qs.get("title") || "",
        productUrl: qs.get("product_url") || "",
        qty: 1
      }];
    }
    QUOTE_BAG_LINES = lines;
    QUOTE_BAG_MODE = lines.length > 0;
    if (quoteSourceField) quoteSourceField.value = source || (QUOTE_BAG_MODE ? "quote_drawer" : "light-quote");

    var summary = document.getElementById("ttq-bag-summary");
    var summaryList = document.getElementById("ttq-bag-summary-list");
    if (!QUOTE_BAG_MODE) {
      if (formEl) formEl.classList.remove("is-quote-bag");
      if (summary) summary.hidden = true;
      if (summaryList) summaryList.innerHTML = "";
      setEquipRequired(true);
      return;
    }

    if (formEl) formEl.classList.add("is-quote-bag");
    setEquipRequired(true);
    if (summary && summaryList) {
      summary.hidden = false;
      summaryList.innerHTML = "";
      lines.forEach(function (item) {
        var li = document.createElement("li");
        var left = document.createElement("span");
        left.textContent = (item.qty ? item.qty + "× " : "") + (item.title || item.sku || "Item");
        var right = document.createElement("span");
        right.textContent = item.variantLabel || item.variantTitle || [item.trackSize, item.treadPattern].filter(Boolean).join(" – ");
        li.appendChild(left);
        li.appendChild(right);
        summaryList.appendChild(li);
      });
    }

    var first = lines[0] || {};
    var bagMake = "";
    var bagModel = "";
    var bagEquip = "";
    lines.forEach(function (item) {
      if (!item) return;
      if (!bagMake) bagMake = String(item.make || item.Make || "").trim();
      if (!bagModel) bagModel = String(item.model || item.Model || "").trim();
      if (!bagEquip) {
        bagEquip = String(item.equipmentHandle || item._equipment || "").trim();
        if (!bagEquip && /-rubber-tracks$/i.test(String(item.handle || ""))) {
          bagEquip = String(item.machineHandle || "").trim();
        }
      }
    });
    if (qs.get("make") && !val("ttq-make")) bagMake = qs.get("make");
    if (qs.get("model") && !val("ttq-model")) bagModel = qs.get("model");
    if (qs.get("equipment") && !bagEquip) {
      var qsEquip = String(qs.get("equipment") || "").trim();
      if (qsEquip && !/^(heavy-duty|bridgestone|standard-duty)-/i.test(qsEquip)) {
        bagEquip = qsEquip;
      }
    }
    if (makeInput && !makeInput.value && bagMake) makeInput.value = bagMake;
    if (modelInput && !modelInput.value && bagModel) modelInput.value = bagModel;
    if (equipmentHandleField && !equipmentHandleField.value && bagEquip) equipmentHandleField.value = bagEquip;
    if (machineDisplayField) {
      machineDisplayField.value = [val("ttq-make"), selectedModelLabel()].filter(Boolean).join(" ");
    }
    var bagMakeLabel = document.getElementById("ttq-make-label");
    var bagModelLabel = document.getElementById("ttq-model-label");
    if (bagMakeLabel) bagMakeLabel.value = val("ttq-make");
    if (bagModelLabel) bagModelLabel.value = selectedModelLabel();
    if (first.productUrl && fitmentUrlField && !fitmentUrlField.value) fitmentUrlField.value = first.productUrl;
    if (variantIdsField) {
      variantIdsField.value = lines.map(function (item) { return item.variantId; }).filter(Boolean).join(",");
    }
    var noteLines = lines.map(bagLineLabel);
    if (variantDetailField) variantDetailField.value = noteLines.join("\n");
    if (quoteLinesField) quoteLinesField.value = noteLines.join("\n");
    if (first.treadPattern && treadSelect && !treadSelect.value) {
      Array.prototype.some.call(treadSelect.options, function (opt) {
        if (opt.value && opt.value.toLowerCase() === String(first.treadPattern).toLowerCase()) {
          treadSelect.value = opt.value;
          return true;
        }
        return false;
      });
    }
    var partHandle = "";
    lines.forEach(function (item) {
      if (partHandle || !item || !item.handle) return;
      if (/-rubber-tracks$/i.test(String(item.handle))) return;
      partHandle = String(item.handle);
    });
    if (partHandle && window.TTMachineSelector && formEl) {
      var sel = formEl.querySelector("[data-tt-machine-selector]");
      fetch("/products/" + encodeURIComponent(partHandle) + "?view=tt-listed-machines", {
        credentials: "omit",
        headers: { Accept: "application/json, text/plain, */*" },
      })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var j = null;
          try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
          if (j && Array.isArray(j.machines) && window.TTMachineSelector.applyListed) {
            window.TTMachineSelector.applyListed(sel, j.machines);
          }
        })
        .catch(function () { /* keep unrestricted selector */ });
    }
  }

  function phoneE164() {
    var el = document.getElementById("ttq-phone");
    var d = el ? el.value.replace(/\D/g, "") : "";
    if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
    return d.length === 10 ? "+1" + d : "";
  }
  var phoneInput = document.getElementById("ttq-phone");
  if (phoneInput) {
    phoneInput.addEventListener("input", function () {
      var digits = this.value.replace(/\D/g, "").slice(0, 10);
      if (digits.length < 4) this.value = digits;
      else if (digits.length < 7) this.value = "(" + digits.slice(0, 3) + ") " + digits.slice(3);
      else this.value = "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
    });
    if (phoneInput.value) phoneInput.dispatchEvent(new Event("input"));
  }
  var zipInput = document.getElementById("ttq-zip");
  if (zipInput) {
    zipInput.addEventListener("input", function () {
      var digits = this.value.replace(/\D/g, "").slice(0, 9);
      this.value = digits.length <= 5 ? digits : digits.slice(0, 5) + "-" + digits.slice(5);
    });
  }
  var stateSelect = document.getElementById("ttq-state");
  if (stateSelect && stateSelect.dataset.prefill && !stateSelect.value) {
    var pre = String(stateSelect.dataset.prefill || "").trim().toUpperCase();
    if (pre.length > 2) pre = pre.slice(0, 2);
    if (pre) stateSelect.value = pre;
  }

  function isFreight() {
    return true;
  }

  function quoteQuery() {
    try { return new URLSearchParams(window.location.search || ""); }
    catch (e) { return new URLSearchParams(); }
  }

  function fitmentContext() {
    var qs = quoteQuery();
    return {
      serial: String(qs.get("serial") || "").trim().toUpperCase(),
      drive: String(qs.get("drive") || "").trim(),
      configuration: String(qs.get("configuration") || "").trim(),
      oemPart: String(qs.get("oem_part") || "").trim(),
      status: String(qs.get("fitment_status") || "").trim(),
      product: String(qs.get("product") || "").trim(),
      variant: String(qs.get("variant") || "").trim(),
      equipment: String(qs.get("equipment") || "").trim()
    };
  }

  function prefillEquipmentFromQuery() {
    var ctx = fitmentContext();
    if (!ctx.equipment || !formEl || !window.TTMachineSelector) return;
    var root = formEl.querySelector("[data-tt-machine-selector]");
    if (!root) return;
    var tries = 0;
    function attempt() {
      tries += 1;
      if (root._ttSelector && typeof root._ttSelector.prefillHandle === "function") {
        root._ttSelector.prefillHandle(ctx.equipment).catch(function () {});
        return;
      }
      if (tries < 30) setTimeout(attempt, 100);
    }
    attempt();
  }

  function quoteSource() {
    return quoteQuery().get("source") || (QUOTE_BAG_MODE ? "quote_drawer" : "light-quote");
  }

  function syncFreightRequired() {
    var freight = isFreight();
    ["ttq-addr-req", "ttq-city-req", "ttq-state-req"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.hidden = !freight;
    });
    ["ttq-addr1", "ttq-city", "ttq-state"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.required = freight;
    });
  }

  function syncShopifyContactFields(forNative) {
    var nameEl = document.getElementById("ttq-contact-name");
    var bodyEl = document.getElementById("ttq-contact-body");
    var fullName = (val("ttq-first") + " " + val("ttq-last")).trim();
    if (nameEl) nameEl.value = fullName;
    var lines = [
      fullName,
      val("ttq-email"),
      phoneE164(),
      val("ttq-company") ? "Company: " + val("ttq-company") : "",
      val("ttq-zip") ? "ZIP: " + val("ttq-zip") : "",
      [val("ttq-addr1"), val("ttq-addr2"), val("ttq-city"), val("ttq-state")].filter(Boolean).join(", "),
      val("ttq-delivery") ? "Delivery: " + val("ttq-delivery") : "",
      marketingOptIn() ? "Marketing emails: yes" : "",
      machineDisplayField && machineDisplayField.value ? "Machine: " + machineDisplayField.value : "",
      bagNotes(),
      val("ttq-notes")
    ].filter(Boolean);
    if (bodyEl) bodyEl.value = lines.join("\n");
    if (forNative) {
      var phoneEl = document.getElementById("ttq-phone");
      if (phoneEl && phoneE164()) phoneEl.value = phoneE164();
    }
  }

  function accountOptIn() {
    var cb = document.getElementById("ttq-create-account");
    return !!(cb && cb.checked);
  }

  function marketingOptIn() {
    var cb = document.getElementById("ttq-marketing");
    return !!(cb && cb.checked);
  }

  function validateInputs() {
    var ok = true;
    ["ttq-first", "ttq-last", "ttq-email", "ttq-phone", "ttq-make", "ttq-model", "ttq-zip", "ttq-addr1", "ttq-city", "ttq-state", "ttq-delivery", "ttq-pass", "ttq-pass2"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.remove("is-invalid");
    });
    if (!val("ttq-first") || !val("ttq-last")) ok = false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val("ttq-email"))) ok = false;
    if (phoneE164().length !== 12) ok = false;
    if (!/^\d{5}(-\d{4})?$/.test(val("ttq-zip"))) {
      var zipEl = document.getElementById("ttq-zip");
      if (zipEl) zipEl.classList.add("is-invalid");
      ok = false;
    }
    if (!val("ttq-delivery")) {
      var deliveryEl = document.getElementById("ttq-delivery");
      if (deliveryEl) deliveryEl.classList.add("is-invalid");
      ok = false;
    }
    ["ttq-addr1", "ttq-city", "ttq-state"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !val(id)) {
        el.classList.add("is-invalid");
        ok = false;
      }
    });
    if (!val("ttq-make") || !val("ttq-model") || !(equipmentHandleField && equipmentHandleField.value)) {
      if (makeInput && !val("ttq-make")) makeInput.classList.add("is-invalid");
      if (modelInput && !val("ttq-model")) modelInput.classList.add("is-invalid");
      ok = false;
    }
    if (configSelect && configSelect.required && !configSelect.value) {
      configSelect.classList.add("is-invalid");
      ok = false;
    }
    if (accountOptIn() && (val("ttq-pass") || val("ttq-pass2"))) {
      var pass = val("ttq-pass");
      var pass2 = val("ttq-pass2");
      if (pass.length < 5 || pass !== pass2) {
        var p1 = document.getElementById("ttq-pass");
        var p2 = document.getElementById("ttq-pass2");
        if (p1) p1.classList.add("is-invalid");
        if (p2) p2.classList.add("is-invalid");
        ok = false;
      }
    }
    if (machineDisplayField) {
      machineDisplayField.value = [val("ttq-make"), selectedModelLabel()].filter(Boolean).join(" ");
    }
    var makeLabelEl = document.getElementById("ttq-make-label");
    var modelLabelEl = document.getElementById("ttq-model-label");
    if (makeLabelEl) makeLabelEl.value = val("ttq-make");
    if (modelLabelEl) modelLabelEl.value = selectedModelLabel();
    syncShopifyContactFields();
    if (!ok) setStatus("error", "Please complete the required fields.");
    return ok;
  }

  function showThanks(result) {
    formEl.style.display = "none";
    thanksEl.hidden = false;
    thanksMetaEl.innerHTML = "";
    if (thanksPriceEl) thanksPriceEl.hidden = true;
    if (thanksCheckout) {
      thanksCheckout.hidden = true;
      thanksCheckout.removeAttribute("href");
    }
    var machine = result && result.machine ? [result.machine.make, result.machine.model].filter(Boolean).join(" ") : "";
    if (!machine && machineDisplayField) machine = machineDisplayField.value;
    if (canShowCertifiedPay(result)) {
      thanksSubEl.textContent = "Price is ready for " + (machine || "this machine") + ".";
      if (thanksPriceEl && result.pricing) {
        thanksPriceEl.hidden = false;
        thanksPriceEl.innerHTML =
          "<div class=\"ttq-thanks-meta-row\"><span class=\"ttq-thanks-meta-key\">Current price</span><span class=\"ttq-thanks-meta-val\">$" + Number(result.pricing.current_price).toFixed(2) + "</span></div>" +
          "<div class=\"ttq-thanks-meta-row\"><span class=\"ttq-thanks-meta-key\">TrackTECH special price</span><span class=\"ttq-thanks-meta-val\">$" + Number(result.pricing.tracktech_price).toFixed(2) + "</span></div>";
      }
      if (thanksCheckout) {
        thanksCheckout.hidden = false;
        thanksCheckout.href = result.checkout_url;
      }
    } else {
      thanksSubEl.textContent = "TrackTECH will review your request, add any discount, and send your quote.";
    }
    var rows = [];
    if (machine) rows.push(["Machine", machine]);
    if (result && result.machine && result.machine.track_size) rows.push(["Track size", result.machine.track_size]);
    (result && result.parts || []).forEach(function (part) {
      rows.push([part.family, (part.qty ? part.qty + "× " : "") + (part.title || "")]);
    });
    if (!rows.length && QUOTE_BAG_LINES.length) {
      QUOTE_BAG_LINES.forEach(function (item) {
        rows.push(["Item", bagLineLabel(item)]);
      });
    }
    rows.forEach(function (row) {
      var div = document.createElement("div");
      div.className = "ttq-thanks-meta-row";
      div.innerHTML = "<span class=\"ttq-thanks-meta-key\"></span><span class=\"ttq-thanks-meta-val\"></span>";
      div.querySelector(".ttq-thanks-meta-key").textContent = row[0];
      div.querySelector(".ttq-thanks-meta-val").textContent = row[1];
      thanksMetaEl.appendChild(div);
    });
    if (rows.length) thanksMetaEl.classList.add("is-active");
    thanksEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function maybeCreateAccount() {
    if (!accountOptIn() || val("ttq-pass").length < 5) return;
    var reg = document.getElementById("ttq-create-customer");
    if (!reg) return;
    var first = document.getElementById("ttq-reg-first");
    var last = document.getElementById("ttq-reg-last");
    var email = document.getElementById("ttq-reg-email");
    var pass = document.getElementById("ttq-reg-pass");
    if (first) first.value = val("ttq-first");
    if (last) last.value = val("ttq-last");
    if (email) email.value = val("ttq-email").toLowerCase();
    if (pass) pass.value = val("ttq-pass");
    var marketing = document.getElementById("ttq-reg-marketing");
    if (marketing) marketing.value = marketingOptIn() ? "1" : "";
    try { reg.submit(); } catch (e) { /* ignore */ }
  }

  function postQuoteRequest(payload) {
    if (CLOSE_LOOP) {
      return fetch(CLOSE_LOOP + "/api/storefront/quote-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload || {}),
        credentials: "omit"
      }).then(function (r) {
        return r.text().then(function (t) {
          var j = null;
          try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
          if (!r.ok) throw new Error((j && j.error) || ("HTTP " + r.status));
          return j;
        });
      }).catch(function (err) {
        console.warn("[ttq] close-loop failed, falling back:", err && err.message);
        return apiPost("/api/storefront/quote-request", payload);
      });
    }
    return apiPost("/api/storefront/quote-request", payload);
  }

  function submitGoverned() {
    LAST_IDEMPOTENCY = LAST_IDEMPOTENCY || uuid();
    return resolveSubmitLines().then(function (resolvedLines) {
      var qs = quoteQuery();
      var first = firstBagVariant() || {};
      if (!first.variantId && resolvedLines[0]) {
        first = {
          variantId: resolvedLines[0].shopify_variant_id || "",
          title: resolvedLines[0].product_title || "",
          sku: resolvedLines[0].sku || "",
          qty: resolvedLines[0].qty || 1,
          trackSize: first.trackSize || ""
        };
      }
      var equipmentText = [val("ttq-make"), selectedModelLabel()].filter(Boolean).join(" ");
      var fitment = fitmentContext();
      var fitmentNotes = [
        fitment.serial ? "Serial: " + fitment.serial : "",
        fitment.drive ? "Drive configuration: " + fitment.drive : "",
        fitment.configuration ? "Machine configuration: " + fitment.configuration : "",
        fitment.oemPart ? "Resolved OEM part: " + fitment.oemPart : "",
        fitment.status ? "Fitment status: " + fitment.status : ""
      ].filter(Boolean).join("\n");
      var notes = [
        val("ttq-notes"),
        bagNotes() ? "Quote bag:\n" + bagNotes() : "",
        fitmentNotes ? "Fitment resolver:\n" + fitmentNotes : ""
      ].filter(Boolean).join("\n\n");
      var payload = {
        customer_name: (val("ttq-first") + " " + val("ttq-last")).trim(),
        first_name: val("ttq-first"),
        last_name: val("ttq-last"),
        customer_email: val("ttq-email").toLowerCase(),
        customer_phone: phoneE164(),
        company: val("ttq-company"),
        accepts_marketing: marketingOptIn(),
        equipment_handle: (equipmentHandleField && equipmentHandleField.value) || fitment.equipment || val("ttq-model") || "",
        equipment_text: equipmentText,
        configuration_key: configSelect && configSelect.value ? configSelect.value : fitment.configuration,
        serial_number: fitment.serial,
        drive_configuration: fitment.drive,
        machine_configuration: fitment.configuration,
        resolved_oem_part: fitment.oemPart,
        fitment_status: fitment.status,
        router_product_handle: fitment.product,
        router_variant_id: fitment.variant,
        machine_make: val("ttq-make"),
        machine_model: selectedModelLabel(),
        track_size: first.trackSize || "",
        tread_pattern: treadSelect ? treadSelect.value : "",
        part_families: collectWantedParts(),
        lines: resolvedLines.length ? resolvedLines : bagLinesPayload(),
        shipping_zip: val("ttq-zip"),
        delivery_type: val("ttq-delivery"),
        address1: val("ttq-addr1"),
        address2: val("ttq-addr2"),
        city: val("ttq-city"),
        state: val("ttq-state"),
        notes: notes,
        qty: Math.max(1, parseInt(first.qty, 10) || 1),
        sku: first.sku || qs.get("sku") || "",
        product_title: first.title || qs.get("title") || "",
        shopify_variant_id: first.variantId || qs.get("variant") || "",
        source: quoteSource(),
        request_path: window.location.pathname + window.location.search,
        customer_fleet_machines: (equipmentHandleField && equipmentHandleField.value)
          ? [{
              handle: equipmentHandleField.value,
              make: val("ttq-make"),
              model: selectedModelLabel(),
              configuration: configSelect && configSelect.value ? configSelect.value : ""
            }]
          : [],
        idempotency_key: LAST_IDEMPOTENCY
      };
      return postQuoteRequest(payload);
    });
  }

  if (formEl && submitBtn) {
    formEl.addEventListener("submit", function (e) {
      if (formEl.dataset.ttqNative === "1") return;
      e.preventDefault();
      if (!validateInputs()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = "Creating quote…";
      setStatus("pending", "Building your TrackTECH quote — one moment…");
      submitGoverned().then(function (result) {
        try {
          var draft = result && result.draft_order ? result.draft_order : {};
          var draftId = result && result.shopify_draft_order_id ? String(result.shopify_draft_order_id) : "";
          var numeric = String(draft.id || draftId).replace(/\D+/g, "");
          var draftNameEl = document.getElementById("ttq-draft-name");
          var draftAdminEl = document.getElementById("ttq-draft-admin");
          var draftInvoiceEl = document.getElementById("ttq-draft-invoice");
          if (draftNameEl) draftNameEl.value = (draft.name || (numeric ? ("Draft #" + numeric) : ""));
          if (draftAdminEl) draftAdminEl.value = draft.admin_url || "";
          if (draftInvoiceEl) draftInvoiceEl.value = draft.invoice_url || result.checkout_url || "";
          syncShopifyContactFields(true);
          maybeCreateAccount();
          formEl.dataset.ttqNative = "1";
          formEl.submit();
        } catch (err) { /* ignore */ }
        try {
          if (QUOTE_BAG_MODE && window.TTQuoteBag && typeof window.TTQuoteBag.clear === "function") {
            window.TTQuoteBag.clear();
          }
        } catch (err2) { /* ignore */ }
        showThanks(result);
      }).catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit Quote Request";
        setStatus("error", (err && err.message) || "Quote request failed. Try again or call (850) 816-7898.");
      });
    });
  }

  if (thanksNewBtn) {
    thanksNewBtn.addEventListener("click", function () {
      LAST_IDEMPOTENCY = "";
      thanksEl.hidden = true;
      formEl.style.display = "";
      formEl.reset();
      formEl.dataset.ttqNative = "";
      hideStamp();
      applyQuoteBag();
    });
  }

  var createAccountCb = document.getElementById("ttq-create-account");
  var accountBox = document.getElementById("ttq-account");
  if (createAccountCb && accountBox) {
    createAccountCb.addEventListener("change", function () {
      accountBox.classList.toggle("is-opt-in", this.checked);
    });
  }

  var bagClear = document.getElementById("ttq-bag-clear");
  if (bagClear) {
    bagClear.addEventListener("click", function () {
      try {
        if (window.TTQuoteBag && typeof window.TTQuoteBag.clear === "function") window.TTQuoteBag.clear();
        window.localStorage.removeItem("tt_quote_bag_v2");
        window.localStorage.removeItem("tt_quote_bag_v1");
      } catch (e) { /* ignore */ }
      QUOTE_BAG_LINES = [];
      QUOTE_BAG_MODE = false;
      applyQuoteBag();
    });
  }

  var deliverySelect = document.getElementById("ttq-delivery");
  if (deliverySelect) {
    deliverySelect.addEventListener("change", syncFreightRequired);
    syncFreightRequired();
  }

  if (formEl) {
    formEl.addEventListener("tt-machine:selected", function (ev) {
      LAST_MACHINE = ev.detail && ev.detail.machine ? ev.detail.machine : null;
      if (window.TTMachineSelector && ev.detail && ev.detail.handle && !ev.detail.needsConfig) {
        window.TTMachineSelector.saveFleet({
          handle: ev.detail.handle,
          name: [ev.detail.make, ev.detail.model].filter(Boolean).join(" "),
          make: ev.detail.make,
          model: ev.detail.model,
          savedAt: Date.now(),
        });
      }
    });
  }

  applyQuoteBag();
  prefillEquipmentFromQuery();
})();
